import { FormattedMessage } from '@src/main/modules/messages/ui/mailbox/model/formated-message.model';
import {
  DataTable,
  DataTableFilterEvent,
  DataTableFilterMeta,
  DataTablePageEvent,
  DataTableSortEvent,
} from 'primereact/datatable';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './MailboxTable.module.scss';

interface Props<T extends FormattedMessage> {
  messages: T[];
  filters: DataTableFilterMeta;
  setFilters: (filters: DataTableFilterMeta) => void;
  header: ReactNode;
  children: ReactNode;
  handleRowSelect: (e: { data: T }) => void;
  dataKey?: string;
  globalFilterFields?: string[];
  onFilter?: (e: DataTableFilterEvent) => void;
  totalRecords: number;
  onPage: (e: DataTablePageEvent) => void;
  first: number;
  rows: number;
  sortField?: string;
  sortOrder?: 1 | -1;
  onSort?: (e: DataTableSortEvent) => void;
}

const MailboxTable = <T extends FormattedMessage>({
  messages,
  filters,
  setFilters,
  header,
  children,
  handleRowSelect,
  dataKey,
  globalFilterFields = ['subject', 'sendBy', 'recipients', 'message'],
  onFilter,
  totalRecords,
  onPage,
  first,
  rows,
  sortField,
  sortOrder,
  onSort,
}: Props<T>) => {
  const { t } = useTranslation();

  return (
    <DataTable
      value={messages}
      paginator
      lazy
      totalRecords={totalRecords}
      onPage={onPage}
      first={first}
      rows={rows}
      rowsPerPageOptions={[10, 20, 50]}
      filters={filters}
      globalFilterFields={globalFilterFields}
      header={header}
      emptyMessage={t('common.emptyMessage')}
      onFilter={(e) => {
        if (onFilter) {
          onFilter(e);
        } else {
          setFilters(e.filters);
        }
      }}
      selectionMode="single"
      onSelectionChange={(e) => {
        if (e.value) handleRowSelect({ data: e.value as T });
      }}
      dataKey={dataKey}
      rowClassName={(rowData) => {
        const isInbox = 'readDate' in rowData;
        const isUnread = isInbox && rowData.readDate === undefined;
        return isUnread ? styles['row-unread'] : '';
      }}
      sortField={sortField}
      sortOrder={sortOrder === 1 ? 1 : -1}
      onSort={onSort}
    >
      {children}
    </DataTable>
  );
};

export default MailboxTable;
